import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ReportsService } from '../../services/report.service';
import { UserService } from '../../services/user.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent implements OnInit {
  public activeAccount;
  public metabaseReportUrl: SafeResourceUrl;
  public loading = true;
  public hasError = false;
  public isProd = environment.PRODUCTION;

  constructor(
    private reports: ReportsService,
    private userService: UserService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.getReports();
  }

  getReports() {
    const companyId = this.userService.getLoggedUser().companyId;
    this.reports.getMetabaseCompanyReport(companyId).then((metabaseUrl) => {
      this.metabaseReportUrl = this.sanitizer.bypassSecurityTrustResourceUrl(metabaseUrl);
    }).catch((error) => {
      this.hasError = true;
      console.error(error);
    }).finally(() => this.loading = false);
  }
}
